<template src="./setup.html"></template>

<script>
import axios from 'axios'
  export default {
    name: 'Setup',
    data: function () {
      return {
        token: null,
        password: null,
        password_confirmation: null,
        success: false
      }
    },
    methods: {
      verify: function () {
        this.swal({
          type: 'info',
          title: 'Verifying your invitaion',
          text: 'Please wait....',
          showConfirmButton: false
        })
        axios.get('/invitation/verify/' + this.token).then(response => {
          this.swal({
            type: 'success',
            title: 'Invitation accepted',
            text: 'To complete your account setup click Ok'
          }).then((result) => {
            this.success = true
          })
        }).catch(exception => {
          this.swal({
            type: 'error',
            title: 'Verification was unsuccessful',
            text: 'Please contact the primary account holder to resend your invitation email'
          })
          this.$router.push('/')
        })
      },
      finish: function () {
        axios.post('/account/setup', { token: this.token, password: this.password, password_confirmation: this.password_confirmation }).then(response => {
          this.swal({
            type: 'info',
            title: 'Setup completed',
            text: 'Your account setup is now complete, you can now login to the Smardie platform.'
          })
          this.$router.push('/login')
        })
      }
    },
    mounted: function () {
      this.token = this.$route.params.token
      this.verify()
    }
  }
</script>

<style scoped>

</style>
